<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // per instance, not shared between components
    this.timeout = null;
    this.requestId = 0;
    this.pendingQuery = null;
    this.destroyed = false;

    GeocoderFactory().then(geocoder => {
      if (this.destroyed) {
        return;
      }

      this.geocoder = geocoder;

      if (this.pendingQuery) {
        const q = this.pendingQuery;
        this.pendingQuery = null;
        this.querySelections(q);
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.reset(false);
  },

  watch: {
    search(val) {
      if (!val || !val.trim()) {
        this.reset(true);
        return;
      }

      // the selected item's text is written back into the input; no new search
      if (this.select && typeof this.select === "object" && val === this.select.text) {
        return;
      }

      if (val !== this.select) {
        this.querySelections(val);
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // stops timer and running request, invalidates late responses
    reset(clearItems) {
      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.requestId++;
      this.pendingQuery = null;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;

      if (clearItems) {
        this.items = [];
      }
    },

    querySelections(value) {
      this.reset(false);

      if (!this.geocoder) {
        this.pendingQuery = value;
        return;
      }

      if (!this.geocoder.hasKey()) {
        this.items = [];
        return;
      }

      this.loading = true;
      const requestId = this.requestId;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoder.autocomplete(value).then(items => {
          if (requestId !== this.requestId) {
            return;
          }

          this.items = items.slice();
        }).catch(err => {
          if (requestId !== this.requestId || (err && err.cancelled)) {
            return;
          }

          this.items = [];
        }).finally(() => {
          if (requestId === this.requestId) {
            this.loading = false;
          }
        });
      }, DEBOUNCE);
    },

    change(o) {
      // keep only the chosen item so it stays displayed; drop older hits
      this.reset(false);
      if (!o || typeof o !== "object") {
        this.items = [];
        return;
      }

      this.items = [o];
      this.$emit("change", o);
    }
  }
};
</script>
